import styles from '../dist/tippy.css'
import tippy from '../src/js/index'
import { injectCSS } from '../src/js/css'

injectCSS(styles)

export default tippy
